var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.9,17.6h-3.7c-0.3,0-0.5,0.1-0.7,0.3l-0.8,0.7c-1.3-3.1-3.2-6.1-5.8-9.2c-1.4-1.7-3.4-2.7-5.6-2.7H17.7c-2.2,0-4.2,1-5.6,2.7c-2.6,3.2-4.5,6.2-5.8,9.2l-0.8-0.7c-0.2-0.2-0.5-0.3-0.7-0.3H1.1c-0.6,0-1.1,0.5-1.1,1.1v2.5c0,0.6,0.4,1,1,1.1l3.8,0.2c-0.6,1.7-1,4.1-1,7.6c0,3,0.6,5,1.7,6.3v5.8c0,0.5,0.4,0.9,0.9,0.9h4.2c0.5,0,0.9-0.4,0.9-0.9v-3.6h27.2v3.6c0,0.5,0.4,0.9,0.9,0.9h4.2c0.5,0,0.9-0.4,0.9-0.9v-5.8c1.1-1.3,1.7-3.3,1.7-6.3c0-3.5-0.4-6-1-7.6l3.8-0.2c0.6,0,1-0.5,1-1.1v-2.5C50,18.1,49.5,17.6,48.9,17.6z M15.1,12c0.6-0.8,1.5-1.2,2.5-1.2h14.7c1,0,1.9,0.4,2.5,1.2c1.8,2.2,3.2,4.3,4.3,6.4l-28.3,0C11.9,16.3,13.3,14.2,15.1,12z M12.1,34.2c-2.1,0-3.8-0.7-3.8-2.3c0-1.6,0.6-3,2.7-3s4.8,1.3,4.8,3C15.8,33.6,14.1,34.2,12.1,34.2z M28.9,33.9h-7.9c-1.2,0-2.2-1-2.2-2.2c0-0.3,0.3-0.6,0.6-0.6h11c0.3,0,0.6,0.3,0.6,0.6C31.1,32.9,30.1,33.9,28.9,33.9z M37.9,34.2c-2.1,0-3.8-0.7-3.8-2.3c0-1.6,2.8-3,4.8-3c2.1,0,2.7,1.3,2.7,3C41.7,33.6,40,34.2,37.9,34.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/motor.1bc38144d100887a4ef908822ec9e1e1.svg";
export { ForwardRef as ReactComponent };